import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AceHighwayAbiInbondEventKeys from '../../../constants/locale/key/AceHighwayAbiInbondEvent'



const ACEHighwayInbondEventTranslationText = () => {

    const { translate } = useTranslation([
        Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT
    ])

    
    let createIn_bondEvent = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.CREATE_IN_BOND_EVENT
    )

    let submitSuccessMsg = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.SUBMIT_SUCCESS_MSG
    )
    let createInbondEvent = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.CREATE_INBOND_EVENT
    )
    let abiInbondEvent = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.TITLE
    )
    let id = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.ID
    )
    let createdBy = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.CREATED_BY
    )
    let createdDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.CREATED_DATE
    )
    let updatedBy = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.UPDATED_BY
    )
    let updatedDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.UPDATED_DATE
    )
    let submittedBy = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.SUBMITTED_BY
    )
    let submittedDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.SUBMITTED_DATE
    )
    let version = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.VERSION
    )
    let partyId = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.PARTY_ID
    )
    let filerCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.FILER_CODE
    )
    let portCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.PORT_CODE
    )
    let msgFunction = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.ACTION_CODE
    )
    let inbond7512No = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.INBOND_NUMBER
    )
    let masterBolIssuerCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.MASTER_BOL_ISSUER_CODE
    )
    let houseBol = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.HOUSE_BOL
    )
    let firmLocation = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.FIRM_LOCATION
    )
    let containerNumber = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.CONTAINER_NUMBER
    )
    let arrivalDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.ARRIVAL_DATE
    )
    let arrivalTime = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.ARRIVAL_TIME
    )
    let inbondDestination = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.ARRIVAL_PORT
    )
    let inbondCarrierCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.INBOND_CARRIER_CODE
    )
    let bondedCarrierId = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.BONDED_CARRIER_ID
    )
    let city = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.CITY
    )
    let stateCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.STATE_CODE
    )
    let exportMot = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.EXPORT_MOT
    )
    let exportConveyance = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.EXPORT_CONVEYANCE
    )
    let status = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.STATUS
    )
    let responseDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.RESPONSE_DATE
    )
    let inbondEventResponse = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.INBOND_EVENT_RESPONSE
    )
    let aceHighwayAbiInbond = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.TITLE
    )
    let actionCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.ACTION_CODE
    )
    let inbondNumber = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.INBOND_NUMBER
    )
    
    let arrivalPort = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.ARRIVAL_PORT
    )
    let editButton = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.EDIT_BUTTON
    )
    let cloneButton = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.CLONE_BUTTON
    )
    let deleteButton = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.DELETE_BUTTON
    )

    let backToInbondArrivalExportList = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.BACK_TO_INBOND_ARRIVAL_EXPORT_LIST
    )
    let saveButton = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.SAVE_BUTTON
    )
    let uploadNewInbond = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.UPLOAD_NEW_INBOND
    )
    let uploadInbondErrorMsg = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.UPLOAD_INBOND_ERROR_MSG
    )
    let masterBol = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.MASTER_BOL
    )
    let actionCodeOriginal = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_ORIGINAL
  )
  let actionCodeChange = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_CHANGE
  )
  let actionCodeCancel = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_CANCEL
  )
  let actionCodeArriveEntireInBond = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_ARRIVE_ENTIRE_IN_BOND
  )
  let actionCodeArriveBillOfLading = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_ARRIVE_BILL_OF_LADING
  )
  let actionCodeArriveContainer = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_ARRIVE_CONTAINER
  )
  let actionCodeExportEntire = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_EXPORT_ENTIRE
  )
  let actionCodeExportBillOfLading = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_EXPORT_BILL_OF_LADING
  )
  let actionCodeExportContainer = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_EXPORT_CONTAINER
  )
  let actionCodeTransferInBond = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_TRANSFER_IN_BOND
  )
  let actionCodeDiversion = translate(
    Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
    AceHighwayAbiInbondEventKeys.ACTION_CODE_DIVERSION
  )

  let statusDraft = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_DRAFT)
    let statusAccepted = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_ACCEPTED)
    let statusAcceptedWithWarning = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_ACCEPTED_WITH_WARNING)
    let statusSent = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_SENT)
    let statusRejected = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_REJECTED)
    let statusNotification = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_NOTIFICATION)
    let statusPreliminary = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_PRELIMINARY)
    let statusCancellationAccepted = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_CANCELLATION_ACCEPTED)
    let statusCancellationRejected = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_CANCELLATION_REJECTED)
    let statusModificationRejected = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_MODIFICATION_REJECTED)
    let statusPL = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_PL)
    let statusCP = translate(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT, AceHighwayAbiInbondEventKeys.STATUS_CP)

    return {
      createIn_bondEvent,
      submitSuccessMsg,
      createInbondEvent,
      abiInbondEvent,
      id,
      createdBy,
      createdDate,
      updatedBy,
      updatedDate,
      submittedBy,
      submittedDate,
      version,
      partyId,
      filerCode,
      portCode,
      msgFunction,
      inbond7512No,
      masterBolIssuerCode,
      houseBol,
      firmLocation,
      containerNumber,
      arrivalDate,
      arrivalTime,
      inbondDestination,
      inbondCarrierCode,
      bondedCarrierId,
      city,
      stateCode,
      exportMot,
      exportConveyance,
      status,
      responseDate,
      inbondEventResponse,
      aceHighwayAbiInbond,
      actionCode,
      inbondNumber,
      arrivalPort,
      editButton,
      cloneButton,
      deleteButton,
      backToInbondArrivalExportList,
      saveButton,
      uploadNewInbond,
      uploadInbondErrorMsg,
      masterBol,
      actionCodeOriginal,
      actionCodeChange,
      actionCodeCancel,
      actionCodeArriveEntireInBond,
      actionCodeArriveBillOfLading,
      actionCodeArriveContainer,
      actionCodeExportEntire,
      actionCodeExportBillOfLading,
      actionCodeExportContainer,
      actionCodeTransferInBond,
      actionCodeDiversion,
      statusDraft,
      statusAccepted,
      statusAcceptedWithWarning,
      statusSent,
      statusRejected,
      statusNotification,
      statusPreliminary,
      statusCancellationAccepted,
      statusCancellationRejected,
      statusModificationRejected,
      statusPL,
      statusCP
    }

}


export default ACEHighwayInbondEventTranslationText

